import React, { forwardRef } from "react";
import AutotaskForm, { AutotaskFormHandle } from "./AutotaskForm";
import ExportPsaForm, { ExportPsaFormHandle } from "./ExportPsaForm";
import { ResolvedIntegration } from "../types/PsaProject";

export type PsaFormHandle = AutotaskFormHandle | ExportPsaFormHandle;

interface Props {
  integration: ResolvedIntegration;
  projectId: string;
  record?: any;
  readOnly?: boolean;
}

const PsaFormDispatcher = forwardRef<PsaFormHandle, Props>((props, ref) => {
  if (props.integration.service === "autotask") {
    return <AutotaskForm ref={ref} {...props} />;
  }
  if (
    props.integration.service === "connectwise" ||
    props.integration.service === "halopsa"
  ) {
    return <ExportPsaForm ref={ref as any} {...props} />;
  }
  return (
    <div style={{ padding: 20 }} data-testid="psa-unsupported">
      This PSA integration type isn&rsquo;t available in the new experience yet.
    </div>
  );
});

PsaFormDispatcher.displayName = "PsaFormDispatcher";
export default PsaFormDispatcher;
